module.exports = __webpack_public_path__ + "fonts/Prompt-ThinItalic.9fc776b0.ttf";